module.exports = __webpack_public_path__ + "static/media/pink-l.b8f733d0.svg";